import React, { useState, useEffect } from 'react';
import { X, Star } from 'lucide-react';

const ReviewPromptModal = ({ onClose }) => {
  const [dismissed, setDismissed] = useState(false);

  const handleDismiss = () => {
    localStorage.setItem('review_prompt_dismissed', 'true');
    setDismissed(true);
    onClose();
  };

  const handleReviewClick = (url) => {
    window.open(url, '_blank');
  };

  const handleDone = () => {
    localStorage.setItem('review_prompt_dismissed', 'true');
    onClose();
  };

  useEffect(() => {
    const permanentlyDismissed = localStorage.getItem('review_prompt_dismissed') === 'true';
    if (permanentlyDismissed) {
      onClose();
      return;
    }
    // Mark as dismissed immediately on show — refresh won't re-show it
    localStorage.setItem('review_prompt_dismissed', 'true');
  }, []);

  if (dismissed) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full mx-4 relative">
        <button
          onClick={handleDismiss}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        <div className="text-center mb-6">
          <div className="flex justify-center mb-3">
            {[...Array(5)].map((_, i) => (
              <Star key={i} size={28} className="text-yellow-400 fill-yellow-400" />
            ))}
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Enjoying MultiSellerPro?</h2>
          <p className="text-gray-500 text-sm">
            You've been with us for a week! If we've helped your business, we'd love a quick review. It takes less than a minute and means the world to us 🙏
          </p>
        </div>

        <div className="flex flex-col gap-3">
          <button
            onClick={() => handleReviewClick('https://www.trustpilot.com/review/multisellerpro.com')}
            className="w-full py-3 px-4 rounded-xl font-semibold text-white flex items-center justify-center gap-2"
            style={{ backgroundColor: '#00b67a' }}
          >
            ⭐ Review on Trustpilot
          </button>

          <button
            onClick={() => handleReviewClick('https://chromewebstore.google.com/detail/multisellerpro/elebkaoefjdagkbfienaoonkgifogkob')}
            className="w-full py-3 px-4 rounded-xl font-semibold text-white bg-blue-600 hover:bg-blue-700 flex items-center justify-center gap-2"
          >
            ⭐ Review the Chrome Extension
          </button>

          <button
            onClick={handleDone}
            className="w-full py-2 text-sm text-gray-400 hover:text-gray-600"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReviewPromptModal;